module.exports = __webpack_public_path__ + "static/media/checkbox_true.63a8a160.svg";